<template>
  <sb-panel
    :heading="content[lang].panels.similar"
    class="sb-similar"
    collection="similar"
  >
    <sb-products
      :errorMessage="content[lang].errors.nosimilar"
      @toggleProducts="toggleSimilar"
      @toggleSimilar="toggleSimilar"
      :products="similarProducts || []"
      collection="similar"
      :collectionPage="similarProductsPage"
      v-if="similarOpen"
    ></sb-products>
  </sb-panel>
</template>

<script>
import sbProducts from "./partials/ProductGrid.vue";
import sbPanel from "./partials/Panel.vue";
import { mapState } from "vuex";

export default {
  props: {
    cid: { type: String },
  },
  computed: mapState([
    "similarProductsPage",
    "similarProducts",
    "similarOpen",
    "uuid",
    "pricer",
    "currencyCode",
    "content",
    "lang",
  ]),
  components: {
    sbProducts,
    sbPanel,
  },
  methods: {
    toggleSimilar(payload) {
      const toggle =
        payload && payload.toggle.toString() ? payload.toggle : true;
      const force = payload && payload.force.toString() ? payload.force : false;
      const reset = payload && payload.reset.toString() ? payload.reset : false;
      const excludeHistory =
        payload && payload.excludeHistory && payload.excludeHistory.toString()
          ? payload.excludeHistory
          : false;
      const filters = this.getDetailsFilters();
      const data = {
        brandR: false,
        page: payload.page,
        numProducts: 3,
        priceR: this.pricer,
        productid: payload.sku,
        site: this.cid,
        uuid: this.uuid,
      };
      if (this.currencyCode) {
        data["currency"] = this.currencyCode;
      }
      filters.forEach((filter) => {
        if (filter) {
          let f = JSON.parse(filter);
          data[f.name] = parseInt(f.data);
          console.log(data);
        }
      });
      const headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        clientID: this.cid,
      };

      this.$store.dispatch("fetchProducts", {
        toggle: toggle,
        force: force,
        reset: reset,
        excludeHistory: excludeHistory,
        panel: "similar",
        data: data,
        headers: headers,
      });
    },
  },
};
</script>

<style scoped>
#shopbox .loading {
  position: absolute;
  left: 2%;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 240px;
}
</style>
